module.exports = __webpack_public_path__ + "static/media/selectra-info.e8723159.webp";